"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostSupplySendEmail = void 0;
const Base_1 = require("./Base");
exports.PostSupplySendEmail = {
    url: Base_1.URL_BASE + "/SupplySendEmail",
    method: "POST",
    secure: true
};
//# sourceMappingURL=PostSupplySendEmail.js.map